import { render } from "./PageVideoReferanslar.vue?vue&type=template&id=2ecc5538"
import script from "./PageVideoReferanslar.vue?vue&type=script&lang=js"
export * from "./PageVideoReferanslar.vue?vue&type=script&lang=js"
script.render = render

export default script